import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { PedidoIsencaoInterface } from 'app/module/pedido-isencao-interface';

@Injectable({
	providedIn: 'root'
})
export class PedidoIsencaoService {
	private url: string = environment.g2e_api;

	private httpOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json; charset=UTF-8',
			'Authorization': 'Bearer ' + localStorage.getItem("tokenApiG2E")
		}),
	}

	constructor(private http: HttpClient) { }

	/**
	 * Retorna lista de todos os pedidos de isenção
	 */
	public get(): Observable<PedidoIsencaoInterface[]> {
		return this.http.get<PedidoIsencaoInterface[]>(`${this.url}pedido-isencao`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}

	/**
	 * Retorna um pedido de isenção específico por ID
	 * @param id - ID do pedido de isenção
	 */
	public getOne(id: number): Observable<PedidoIsencaoInterface> {
		return this.http.get<PedidoIsencaoInterface>(`${this.url}pedido-isencao/${id}`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}

	/**
	 * Cria um novo pedido de isenção
	 * @param data - Dados do pedido de isenção
	 */
	public post(data: PedidoIsencaoInterface): Observable<any> {
		return this.http.post<any>(`${this.url}pedido-isencao/create`, {
			data
		}, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}

	/**
	 * Atualiza um pedido de isenção existente
	 * @param id - ID do pedido de isenção
	 * @param data - Dados a serem atualizados
	 */
	public put(id: number, data: PedidoIsencaoInterface): Observable<any> {
		return this.http.put<any>(`${this.url}pedido-isencao/${id}`, {
			data
		}, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}

	/**
	 * Deleta um pedido de isenção
	 * @param id - ID do pedido de isenção
	 */
	public delete(id: number): Observable<any> {
		return this.http.delete<any>(`${this.url}pedido-isencao/${id}`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}
}
